module.exports = __webpack_public_path__ + "img/bell-01.4e7ffffd.png";